import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OEBayerTargetType = {
    anatomy:        'anatomy',
    bayer:          'bayer',
    surgery:        'surgery',
    opti:           'opti',
    oct:            'oct'
};

OEBayerTargetType.all = [
    OEBayerTargetType.anatomy,
    OEBayerTargetType.bayer,
    OEBayerTargetType.surgery,
    OEBayerTargetType.opti,
    OEBayerTargetType.oct
];

export const OEBayerStartSelectionContent = {
    [OEBayerTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.humanEyeLid,
                        OETargetMenuDefs.sensorySystemsEye,
                        OETargetMenuDefs.humanEyeMuellerCell
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.bayer]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeAMD,
                        OETargetMenuDefs.humanEyeDMOE,
                        OETargetMenuDefs.humanEyeOcclusion
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanEyeMembrane
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.surgery]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryEyeCataract
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.opti]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.zeissOpti2,
                        OETargetMenuDefs.humanEyeAmetropia
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.oct]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeOCT
                    ]
                }
            ]
        }
    ],

    [OEBayerTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.humanEyeLid,
                        OETargetMenuDefs.sensorySystemsEye,
                        OETargetMenuDefs.humanEyeMuellerCell
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.bayer + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeAMD,
                        OETargetMenuDefs.humanEyeDMOE,
                        OETargetMenuDefs.humanEyeOcclusion
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanEyeMembrane
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.surgery + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryEyeCataract
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.opti + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.zeissOpti2,
                        OETargetMenuDefs.humanEyeAmetropia
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.oct + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeOCT
                    ]
                }
            ]
        }
    ],

    [OEBayerTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEye2,
                        OETargetMenuDefs.humanEyeRetina,
                        OETargetMenuDefs.humanEyeCornea,
                        OETargetMenuDefs.humanEyeLid,
                        OETargetMenuDefs.sensorySystemsEye,
                        OETargetMenuDefs.humanEyeMuellerCell
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.bayer + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeAMD,
                        OETargetMenuDefs.humanEyeDMOE,
                        OETargetMenuDefs.humanEyeOcclusion
                    ]
                },
                {
                    items: [
                        OETargetMenuDefs.humanEyeMembrane
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.surgery + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.surgeryEyeCataract
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.opti + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.zeissOpti2,
                        OETargetMenuDefs.humanEyeAmetropia
                    ]
                }
            ]
        }
    ],
    [OEBayerTargetType.oct + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanEyeOCT
                    ]
                }
            ]
        }
    ]
};

OEBayerStartSelectionContent.modules = [
    {id: OEBayerTargetType.anatomy, icon: OEIconCodes.bayer.anatomyTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.anatomy]},
    {id: OEBayerTargetType.bayer, icon: OEIconCodes.bayer.bayerTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.bayer]},
    {id: OEBayerTargetType.surgery, icon: OEIconCodes.bayer.surgeryTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.surgery]},
    {id: OEBayerTargetType.opti, icon: OEIconCodes.bayer.optiTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.opti]},
    {id: OEBayerTargetType.oct, icon: OEIconCodes.bayer.octTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.oct]}
];

OEBayerStartSelectionContent.modulesBeta = [
    {id: OEBayerTargetType.anatomy, icon: OEIconCodes.bayer.anatomyTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
    {id: OEBayerTargetType.bayer, icon: OEIconCodes.bayer.bayerTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.bayer + OEAlphaBetaProdTypes.beta]},
    {id: OEBayerTargetType.surgery, icon: OEIconCodes.bayer.surgeryTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.surgery + OEAlphaBetaProdTypes.beta]},
    {id: OEBayerTargetType.opti, icon: OEIconCodes.bayer.optiTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.opti + OEAlphaBetaProdTypes.beta]},
    {id: OEBayerTargetType.oct, icon: OEIconCodes.bayer.octTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.oct + OEAlphaBetaProdTypes.beta]}
];

OEBayerStartSelectionContent.modulesProduction = [
    {id: OEBayerTargetType.anatomy, icon: OEIconCodes.bayer.anatomyTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
    {id: OEBayerTargetType.bayer, icon: OEIconCodes.bayer.bayerTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.bayer + OEAlphaBetaProdTypes.prod]},
    {id: OEBayerTargetType.surgery, icon: OEIconCodes.bayer.surgeryTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.surgery + OEAlphaBetaProdTypes.prod]},
    {id: OEBayerTargetType.opti, icon: OEIconCodes.bayer.optiTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.opti + OEAlphaBetaProdTypes.prod]},
    {id: OEBayerTargetType.oct, icon: OEIconCodes.bayer.octTarget, categories: OEBayerStartSelectionContent[OEBayerTargetType.oct + OEAlphaBetaProdTypes.prod]}
];